module.exports = __webpack_public_path__ + "static/media/teacher23.42ae3d10.png";